// import './globals.css'
// import './booking-flow.scss'
// import 'libs/styles/utilities/layout.css'

type Route = {
  path: string
  stepNumber?: number
  text: string
}

export const routes: Route[] = [
  { path: '/book/ship', stepNumber: 1, text: 'Step 1 - Non-Booking Widget Flow' },
  { path: '/book/login', stepNumber: 2, text: 'Step 2 - Login Gate' },
  { path: '/book/travelers', stepNumber: 2, text: 'Step 2 - Traveler Details' },
  { path: '/book/pay', stepNumber: 3, text: 'Step 3 - Additional options & payment details' },
  { path: '/book/review', stepNumber: 4, text: 'Step 4 - Review Order' },
  { path: '/order-confirmation', text: 'Order Confirmation' },
  { path: '/users/password/edit', text: 'Reset Password' },
]
